import { Injectable } from '@angular/core';
import {AngularFirestore} from '@angular/fire/firestore'

@Injectable({
  providedIn: 'root'
})
export class FireService {

  constructor(public db: AngularFirestore) { }

  getData(){
    return this.db.collection('projects').valueChanges()
  }

  getId(){
    return this.db.collection("projects").snapshotChanges()
  }

  getSingleId(project){
    return this.db.doc("projects/" + project).valueChanges()
  }

  putData(project){
    const initialPut = this.db.collection('offers')
    return (
      initialPut.add(({
        email: project.email,
        message: project.message
      }))
    )
  }

}
